import { trimSubscribedMod } from '@serializers/modConverter.js'
import { LS_SUBSCRIPTIONS } from '@config/localstorage.js'
import modSerializer from '@serializers/modSerializer.js'
import useStorage from '@composables/useStorage.js'
import { isArray } from '@helpers/utils.js'
import { GAME_ID } from '@config/game.js'
import { computed } from 'vue'

const subscriptionState = useStorage(LS_SUBSCRIPTIONS, null, false)

export default function () {
  const subscriptions = computed(() => {
    try {
      const json = JSON.parse(subscriptionState.value)
      if (isArray(json)) return json
    } catch (error) {
      console.error(error)
    }
    return []
  })

  function clearSubscriptions() {
    subscriptionState.value = JSON.stringify(
      subscriptions.value.filter((m) => m.game_id !== GAME_ID)
    )
  }

  function setMySubscriptions(_subscriptions) {
    const data = modSerializer
      .transform({ data: _subscriptions })
      .data.map(trimSubscribedMod)

    const filtered = subscriptions.value.filter((m) => m.game_id !== GAME_ID)
    subscriptionState.value = JSON.stringify([...filtered, ...data])

    return data
  }

  // use game and mod id
  function addSubscription(modId, modData) {
    if (!subscriptions.value.find((sub) => sub && sub.id === parseInt(modId))) {
      const transformedMod = modSerializer
        .transform({ data: [modData] })
        .data.map(trimSubscribedMod)[0]

      subscriptionState.value = JSON.stringify([
        ...subscriptions.value,
        transformedMod,
      ])
    }
  }

  // use game and mod id
  function removeSubscription(modId) {
    const updated = subscriptions.value.filter(
      (subscription) => subscription && subscription.id !== parseInt(modId)
    )

    subscriptionState.value = JSON.stringify(updated)
  }

  function hasSubscriptionForUser(userNameId) {
    return computed(() =>
      subscriptions.value?.some(
        (mod) => mod.submitted_by.name_id === userNameId
      )
    )
  }

  return {
    hasSubscriptionForUser,
    setMySubscriptions,
    clearSubscriptions,
    removeSubscription,
    addSubscription,
    subscriptions,
  }
}
